<template>
    <h4 class="text-center">
        <span v-if="! updating" :class="'iconify ' + trendColor " :data-icon="trendIcon" data-height="30px" data-inline="false"></span> <br />

        <template v-if="updating">
            <span :class="trendColor">Updating</span>
        </template>
        <template v-else>
            <span :class="trendColor">{{ val || defaultTitle }}</span>
        </template>

        <span
            data-height="12px"
            :class="'iconify mb-3 ' + trendColor"
            data-icon="bi:info-circle"
            data-inline="false"
            role="button"
            tabindex="0"
            :data-bs-toggle="locked ? '' : 'popover'"
            data-bs-trigger="focus"
            :data-bs-content="content"
            v-if="! updating"
        ></span>
    </h4>
</template>

<script>
export default {
    name: 'InfoRating',
    props: {
        locked: { default: false},
        updating: { default: false},
        val: { required: true },
        content: { required: true },
        defaultTitle: { default: 'N/A' },
        trendIcon: { default: 'ph:trend-up-bold'},
        trendColor: { default: 'text-success'}
    }
}
</script>
